import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M17.824 8.75h-2.13c-.691 0-1.25-.56-1.25-1.25V4.965l3.38 3.785Zm-4.88-5V7.5a2.75 2.75 0 0 0 2.75 2.75h3.056V19c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h6.443ZM20.25 9.5V19a2.75 2.75 0 0 1-2.75 2.75h-11A2.75 2.75 0 0 1 3.75 19V5A2.75 2.75 0 0 1 6.5 2.25h7.193a.75.75 0 0 1 .56.25L20.059 9a.75.75 0 0 1 .19.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M7.25 8A.75.75 0 0 1 8 7.25h2a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Zm0 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM8 16.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorFile;
